export type CookieConsent = "accepted" | "declined";

const STORAGE_KEY = "barcraft.cookieConsent";
const RESET_EVENT = "barcraft:cookie-consent-reset";

export function getConsent(): CookieConsent | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === "accepted" || value === "declined" ? value : null;
  } catch (e) {
    return null;
  }
}

export function acceptCookies(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "accepted");
  } catch (e) {
    // Ignore
  }
  fetch("/api/consent/accept", { method: "POST" }).catch(() => {});
}

export function declineCookies(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "declined");
  } catch (e) {
    // Ignore
  }
  fetch("/api/consent/decline", { method: "POST" }).catch(() => {});
}

/**
 * Lets the footer's "cookie settings" link reopen the banner from outside
 * its component tree — clears the stored choice and notifies any mounted
 * banner via a window event, since the banner and footer don't share state.
 */
export function resetConsent(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Ignore
  }
  window.dispatchEvent(new Event(RESET_EVENT));
}

export function onConsentReset(handler: () => void): () => void {
  window.addEventListener(RESET_EVENT, handler);
  return () => window.removeEventListener(RESET_EVENT, handler);
}
